import React from 'react'

const HowItWorks = () => (
  <section className="vt-section" id="how-it-works">
    <div className="vt-shell">
      <div className="sec-head">
        <span className="eyebrow">Comment ça marche</span>
        <h2>Trois étapes. C'est prescrit.</h2>
        <p>Du patient à la prescription dans la boîte mail du client.</p>
      </div>

      <div className="steps">
        {/* Step 1 — Patient profile */}
        <div className="step">
          <div className="step__crop">
            <div className="crop-profile">
              <div className="crop-field"><span className="k">Nom</span><span className="v">Oscar</span></div>
              <div className="crop-field"><span className="k">Espèce</span><span className="v">Chien</span></div>
              <div className="crop-field"><span className="k">Poids</span><span className="v">12,4 kg</span></div>
              <div className="crop-be"><span className="k">BCS</span><span className="v">5/9</span></div>
            </div>
          </div>
          <div className="step__txt">
            <div className="step__n" />
            <h3>Profil du patient</h3>
            <p>Espèce, race, poids, BCS, statut — un formulaire clair cerne les besoins nutritionnels de ton patient.</p>
          </div>
        </div>

        {/* Step 2 — Build the recipe */}
        <div className="step">
          <div className="step__crop">
            <div className="crop-chips">
              <span className="crop-chip crop-chip--ok">Protéines ✓</span>
              <span className="crop-chip crop-chip--ok">Lipides ✓</span>
              <span className="crop-chip crop-chip--ok">Calcium ✓</span>
              <span className="crop-chip crop-chip--warn">Zinc ⚠</span>
              <span className="crop-chip crop-chip--ok">Ca/P ✓</span>
              <span className="crop-chip crop-chip--ok">Énergie ✓</span>
            </div>
            <div style={{ marginTop: 12, display: 'flex', gap: 8, alignItems: 'center' }}>
              <div style={{
                padding: '6px 12px', borderRadius: 'var(--radius-pill)',
                background: 'var(--status-ok-bg)', border: '1px solid var(--status-ok-border)',
                fontFamily: 'var(--font-ui)', fontWeight: 800, fontSize: 12, color: 'var(--status-ok-fg)'
              }}>
                AutoPilot ON
              </div>
            </div>
          </div>
          <div className="step__txt">
            <div className="step__n" />
            <h3>Construis la ration</h3>
            <p>Ajoute, enlève, ajuste — l'AutoPilot équilibre en temps réel contre 40+ nutriments.</p>
          </div>
        </div>

        {/* Step 3 — Send prescription */}
        <div className="step">
          <div className="step__crop">
            <div className="crop-send">
              <div className="crop-pdf">
                <div className="crop-pdf__lines">
                  <i className="t" /><i className="s" /><i className="m" /><i className="s" /><i /><i className="m" /><i className="s" />
                </div>
              </div>
              <span style={{ fontFamily: 'var(--font-ui)', fontWeight: 800, fontSize: 13, color: 'var(--text-strong)' }}>
                Prescription PDF
              </span>
              <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                → boîte mail du client
              </span>
            </div>
          </div>
          <div className="step__txt">
            <div className="step__n" />
            <h3>Envoie la prescription</h3>
            <p>Un clic : la prescription validée, avec tes coordonnées, arrive chez le propriétaire.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default HowItWorks
